import "./RadioButtonGroup.css";

export default function RadioButtonGroup({
  name,
  value,
  onChange,
  options = [],
  className = "",
  disabled = false,
}) {
  return (
    <div
      className={`radio-button-group${disabled ? " radio-button-group-disabled" : ""}${className ? ` ${className}` : ""}`}
      role="radiogroup"
      aria-label={name}
      aria-disabled={disabled}
    >
      {options.map((option) => {
        const checked = value === option.value;
        return (
          <label
            key={option.value}
            className={`radio-button-option radio-button-option-${option.tone || "default"}${checked ? " radio-button-option-active" : ""}${disabled ? " radio-button-option-disabled" : ""}`}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={checked}
              onChange={() => {
                if (!disabled) onChange(option.value);
              }}
              className="radio-button-input"
              disabled={disabled}
            />
            <span className="radio-button-indicator" aria-hidden="true" />
            {option.icon && (
              <option.icon size={14} className="radio-button-icon" aria-hidden="true" />
            )}
            <span className="radio-button-label">{option.label}</span>
          </label>
        );
      })}
    </div>
  );
}
